import React from 'react';
import { useDispatch } from 'react-redux';
import { openChat } from '../../redux/AIChatSlice/aiChatSlice';
import { MessageCircle } from 'lucide-react';

const AIAssistantButton = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(openChat());
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-[90] w-14 h-14 bg-gradient-to-r from-[#3F57E0] to-[#7B61FF] hover:from-[#3548C7] hover:to-[#6A52E6] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group animate-pulse hover:animate-none"
      aria-label="Open Career Champ Assistant"
      title="Chat with Career Champ"
    >
      <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
    </button>
  );
};

export default AIAssistantButton;
